<template>
    <div class='bread' style="min-width:1066px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item  v-for='(item,ind) in paths' :key="ind" @click="jumpTo(item)">{{item.tittle}}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <div style="display:flex;">
            <h4 class="title" v-if="paths.length > 1">{{paths[2]}}</h4>
            <p class="desc" v-if="desc">
               <i class="el-icon-warning" style="color:#FE4D45; marginRight: 4px;"></i>{{desc}}
            </p>
        </div> -->
    </div>
</template>


<script>
export default {
    name: "bread-path",
    props:{
        paths:{
            type:Array,
            require:true
        },
        desc: {
            type: String,
            default: null
        }
    },
    data() {
        return {
        }
    },
    created() {
    },
    computed: {
    },
    mounted(){
      // console.log(this.paths,"=====================>");
    },
    methods:{
      jumpTo(item){
        
      },
    }
}
</script>
<style lang="scss" scoped>
   .bread{
       box-sizing: border-box;
       padding: 0 20px;
       margin: 0;
    //    height: 90px;
    //    background: #fff;
    //    box-shadow:0px 4px 8px rgba(0,0,0,0.1);
       .el-breadcrumb{
        //   height: 32px;
        //   line-height: 32px !important;
          line-height: 18px !important;
          padding-top: 12px;
          display: inline-block;

       }
       .title {
           margin: 16px 0 0 0;
           font-size: 20px;
       }
       .desc {
            margin: 16px 0 0 12px;
            box-sizing: border-box;
            padding: 0 12px;
            height: 28px;
            line-height: 26px;
            background:rgba(254,77,69,0.06);
            border:1px solid rgba(254,77,69,0.6);
            border-radius:2px;
            color: #333333;
            font-size: 14px;
       }
   }
</style>